export default "__VITE_ASSET__a4f9ebe6__"